require('babel-polyfill');

import componentLoader from 'utils/component_loader';

window.ConsentHub = require('atlassian/consent_hub');

componentLoader({
  ConfirmModal: require('components/confirm'),
  AccessControlSearch: require('components/manage/access_control_search'),
  BetterErrorPagesGetStarted: require('components/better_error_pages/get_started'),
  ComponentToggler: require('components/component_groups'),
  ComponentStatuses: require('components/manage/pages/components/component_statuses'),
  HostHelper: require('components/manage/pages/host_helper'),
  ExceedingAllocationsDashboard: require('components/manage/admin/exceeding_allocations/exceeding_allocations_dashboard'),
  ImportSubscriberForm: require('components/manage/pages/notifications/import_subscriber_form'),
  IncidentsSearchField: require('components/manage/incidents_search_field'),
  IncidentTemplates: require('components/manage/incident_templates/incident_templates'),
  IncidentTemplateForm: require('components/manage/incident_templates/incident_template_form'),
  ItemsSelector: require('components/items_selector/items_selector'),
  ModifyUser: require('components/manage/organizations/modify_user'),
  OrganizationPages: require('components/manage/admin/organizations/pages'),
  PageAccessUsersForm: require('components/manage/page_access_users/form'),
  PageAccessSearchField: require('components/manage/page_access_search_field'),
  PageSubscription: require('components/manage/admin/pages/subscription'),
  NotificationsSubscriberManager: require('components/manage/notifications/notifications_subscriber_manager'),
  ResendConfirmationLink: require('components/resend_confirmation_link'),
  SingleSignOnForm: require('components/manage/pages/single_sign_on_form'),
  SsoMetrics: require('components/manage/shared/sso_metrics'),
  StrideConversations: require('components/manage/stride_conversations'),
  StrideConversationsAdminInfo: require('components/manage/stride_conversations_admin_info'),
  SubscribersSearchField: require('components/manage/subscribers_search_field'),
  UnsubscribeButton: require('components/manage/unsubscriber'),
  ManageSubscription: require('containers/status/manage'),
  BackfillDateTimePicker: require('components/backfill_date_time_picker'),
});



// WEBPACK FOOTER //
// ./app/javascript/packs/components.js